/* eslint-disable react/jsx-one-expression-per-line */
import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  Dispatch,
  SetStateAction,
} from 'react';
import { Box, Backdrop, CircularProgress } from '@material-ui/core';
import { UPLOAD_IMAGE_SITE } from '../../queries/site';
import { readFileAsync } from '../../utils/readFileAsync';
import useStyles from './styles';
// TODO Remove
import './Dropzone.css';
import { request } from '../../utils/request';
import { ITreatedFile } from '../BlocksContents/BlocksContents';

interface IDropzonePros {
  setTreatedFiles: Dispatch<SetStateAction<ITreatedFile[]>>;
  siteDomain: string;
}

const Dropzone: React.FC<IDropzonePros> = ({ setTreatedFiles, siteDomain }) => {
  const classes = useStyles();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const [validFiles, setValidFiles] = useState<File[]>([]);
  const [unsupportedFiles, setUnsupportedFiles] = useState<File[]>([]);
  // TODO Remove
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [backdropOpen, setBackdropOpen] = useState(false);

  const handleCloseBackdrop = () => {
    setBackdropOpen(false);
  };

  useEffect(() => {
    if (selectedFiles.length > 0) {
      // const filteredArr = selectedFiles.reduce((result, current) => {
      //   const x = result.find(fileInResult => fileInResult.name === current.name);
      //   if (!x) {
      //     return result.concat([current]);
      //   }
      //   return result;
      // }, []);
      setValidFiles([...selectedFiles]);
      setSelectedFiles([]);
    }
  }, [selectedFiles]);

  const preventDefault = (e: React.DragEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleFileInputClick = () => {
    // eslint-disable-next-line no-unused-expressions
    fileInputRef.current?.click?.();
  };

  const fileExtensionIsValid = (file: File) => {
    const validTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/x-icon',
      'image/webp',
    ];

    if (validTypes.includes(file.type)) {
      return true;
    }

    return false;
  };

  // TODO pass to parent (onFilesChange [...])
  const handleFiles = (files: FileList) => {
    for (let i = 0; i < files.length; i += 1) {
      const currentFile = files[i];

      if (fileExtensionIsValid(currentFile)) {
        setSelectedFiles((prevArray) => [...prevArray, currentFile]);
      } else {
        setSelectedFiles((prevArray) => [...prevArray, currentFile]);
        setUnsupportedFiles((prevArray) => [...prevArray, currentFile]);
      }
    }
  };

  const handleFileDrop = (e: React.DragEvent<HTMLElement>) => {
    preventDefault(e);
    const { files } = e.dataTransfer;
    if (files.length) {
      handleFiles(files);
    }
  };

  const handleFilesChange = () => {
    if (fileInputRef.current?.files?.length) {
      handleFiles(fileInputRef.current.files);
    }
  };

  const uploadFiles = useCallback(async () => {
    setBackdropOpen(true);

    // const uri = getUri(window.location.hostname);
    // const headers = {
    //   'content-type': 'application/json',
    //   authorization: `Bearer ${localStorage.getItem('accessToken')}`,
    // };

    const promises = validFiles.map(async (file) => {
      const imageBase64: string = await readFileAsync(file);

      const response = await request(UPLOAD_IMAGE_SITE, {
        file: imageBase64,
        fileName: file.name,
        siteDomain,
      });
      // const response = await axios({
      //   url: uri,
      //   method: 'POST',
      //   data: {
      //     query: UPLOAD_IMAGE_SITE,
      //     variables: {
      //       file: readerResult,
      //       fileName: file.name,
      //       siteDomain,
      //     },
      //   },
      //   headers,
      // });
      const {
        data: {
          uploadImageContent: { url },
        },
      } = response;

      return {
        fileContent: `<figure class="image"><img src="${url}"></figure>`,
        fileName: file.name.split('.')[0],
      };
    });
    const contents: ITreatedFile[] = await Promise.all(promises);

    setTreatedFiles(contents);
    setValidFiles([]);
    setBackdropOpen(false);
  }, [setTreatedFiles, siteDomain, validFiles]);

  useEffect(() => {
    if (validFiles.length > 0) {
      uploadFiles();
    }
  }, [validFiles, uploadFiles]);

  return (
    <>
      <Box className="container">
        <Backdrop
          className={classes.backdrop}
          open={backdropOpen}
          onClick={() => handleCloseBackdrop()}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {unsupportedFiles.length > 0 && (
          <p>Please remove all unsupported files.</p>
        )}
        <Box
          className="drop-container"
          onDragOver={preventDefault}
          onDragEnter={preventDefault}
          onDragLeave={preventDefault}
          onDrop={handleFileDrop}
          onClick={handleFileInputClick}
        >
          <Box className="drop-message">
            <Box className="upload-icon" />
            Drag & Drop files <b>here</b> or click to <b>browse</b>
          </Box>
          <input
            ref={fileInputRef}
            className="file-input"
            type="file"
            multiple
            onChange={handleFilesChange}
          />
        </Box>
      </Box>
    </>
  );
};

export default Dropzone;
